import {
  BulkStaticDoctorProfileImportRequest,
  StaticDoctorProfileDto,
  StaticDoctorProfileImportValidation,
} from "../types/staticDoctorProfile.definition";
import {
  bulkImportStaticDoctorProfiles,
  getAllStaticDoctorProfiles,
  inviteFromStaticDoctorProfile,
  validateBulkImportStaticDoctorProfiles,
} from "../webclients/staticDoctorProfile.client";

export const staticDoctorProfileApi = {
  bulkImport: async (
    data: BulkStaticDoctorProfileImportRequest
  ): Promise<StaticDoctorProfileDto[]> => {
    const response = await bulkImportStaticDoctorProfiles(data);
    return response.data;
  },
  /** MED-1474: dry run — always resolves, with the per-row errors of the real import. */
  validateBulkImport: async (
    data: BulkStaticDoctorProfileImportRequest
  ): Promise<StaticDoctorProfileImportValidation> => {
    const response = await validateBulkImportStaticDoctorProfiles(data);
    return response.data;
  },
  getAll: async (): Promise<StaticDoctorProfileDto[]> => {
    const response = await getAllStaticDoctorProfiles();
    return response.data;
  },
  inviteFromProfile: async (id: number): Promise<StaticDoctorProfileDto> => {
    const response = await inviteFromStaticDoctorProfile(id);
    return response.data;
  },
};

export default staticDoctorProfileApi;
